// extracted by mini-css-extract-plugin
export default {"itemContainer":"RndItem_itemContainer__NJe1R","innerBox":"RndItem_innerBox__7OBgp"};